import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=62927c78&scoped=true"
import script from "./CommentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=62927c78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62927c78",
  null
  
)

export default component.exports